import styled from 'styled-components/native'

import { FontSizes } from 'widgets/Text'

import { ThemeColor, ThemeFontWeight } from 'utils/themes/types'

import { ThemeI } from 'types/styled'

type Props = {
  fontWeight: ThemeFontWeight
  size: FontSizes
  color?: ThemeColor
}

export const HeadingStyledTitle = styled.Text<Props>`
  font-family: ${({ fontWeight }) =>
    // eslint-disable-next-line no-nested-ternary
    fontWeight === 'bold'
      ? 'Poppins-SemiBold'
      : fontWeight === 'black'
      ? 'Poppins-Black'
      : 'Poppins'};
  color: ${({ color = 'text', theme }) => theme.colors[color]};
  font-size: ${({ theme, size }) => theme.fonts.sizes[size] * 1.5}px;
  font-weight: ${({ theme, fontWeight }: { theme: ThemeI; fontWeight: ThemeFontWeight }) =>
    theme.fonts.weights[fontWeight]};
`
